export default "__VITE_ASSET__5RvhUqTT__"